import { render, staticRenderFns } from "./customer_zi_list.vue?vue&type=template&id=7a9576cc&scoped=true"
import script from "./customer_zi_list.vue?vue&type=script&lang=js"
export * from "./customer_zi_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9576cc",
  null
  
)

export default component.exports